export const BLIPP_FEE_PERCENT = 1;
